import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SupportService } from '../../_core/_services/support/support.service';

@Component({
  selector: 'app-reactivate-account',
  standalone: false,
  templateUrl: './reactivate-account.html',
  styleUrl: './reactivate-account.css'
})
export class ReactivateAccount implements OnInit {
  loading = true;
  status = '';
  message = '';
  error = '';
  ticketId: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private supportService: SupportService
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token')?.trim() || '';

    if (!token) {
      this.loading = false;
      this.error = 'The account reactivation link is missing its verification token.';
      return;
    }

    this.supportService.confirmAccountReactivation(token).subscribe({
      next: (res) => {
        this.status = res.data?.status || '';
        this.message = res.data?.message || res.message ||
          'The account reactivation request was processed.';
        this.ticketId = res.data?.ticketId || null;
      },
      error: (err) => {
        this.error = err?.error?.message ||
          err?.error?.error?.details ||
          'The account reactivation link is invalid or has expired.';
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  isSuccessful(): boolean {
    return this.status === 'PendingReview' || this.status === 'AlreadyActive';
  }
}
